import { useMemoryData } from "@crystal/core";
import { request } from "@crystal/http";
const translationsBaseUrl = "https://translations.glass.3stripes.net/api/projects";
const cacheStore = useMemoryData("crystal_translationsCache", () => /* @__PURE__ */ new Map());
const promiseStore = useMemoryData("crystal_translationsPromise", () => /* @__PURE__ */ new Map());
async function loadTranslations(project, namespace, locale) {
  const cacheKey = getCacheKey(project, namespace, locale);
  const cacheData = cacheStore().get(cacheKey);
  if (cacheData)
    return cacheData;
  let promise = promiseStore().get(cacheKey);
  if (promise)
    return promise;
  const translationsUrl = `${translationsBaseUrl}/${project}/namespaces/${namespace}/translations/${locale}/keys`;
  promise = request(translationsUrl).then((data) => cacheStore().set(cacheKey, data).get(cacheKey)).catch((err) => {
    promiseStore().delete(cacheKey);
    return Promise.reject(err);
  });
  promiseStore().set(cacheKey, promise);
  return promise;
}
function getCacheKey(project, namespace, locale) {
  return `${project}_${namespace}_${locale}`;
}
export {
  loadTranslations
};
//# sourceMappingURL=api.js.map
